import { css } from '../utils.js';
import chroma from 'chroma-js';

const themedStyles = css`
    .ddk-container .PresetDateRangePicker_button {
      background: none;
      border: 2px solid ${props => props.theme.control_border.color};
      color: ${props => props.theme.control_text};
    }
    .ddk-container .PresetDateRangePicker_button__selected {
      color: ${props => props.theme.control_text};
      background: ${props => props.theme.background};
    }
    .ddk-container .SingleDatePickerInput {
      background-color: ${props => props.theme.control_background_color};
    }
    .ddk-container .SingleDatePickerInput__withBorder {
      border-color: ${props => props.theme.control_border.color};
    }
    .ddk-container .SingleDatePickerInput__disabled {
      background: none;
    }
    .ddk-container .SingleDatePickerInput_clearDate__default:focus {
      background: ${props => props.theme.accent};
    }
    .ddk-container .SingleDatePickerInput_clearDate__default:hover {
      background: ${props => props.theme.accent};
    }
    .ddk-container .SingleDatePickerInput_clearDate_svg {
      fill: ${props => props.theme.control_border.color};
    }
    .ddk-container .SingleDatePickerInput_calendarIcon_svg {
      fill: ${props => props.theme.control_border.color};
    }
    .ddk-container .SingleDatePicker_picker {
      background-color: ${props => props.theme.control_background_color};
    }
    .ddk-container .SingleDatePicker_picker__portal {
      background-color: rgba(0, 0, 0, 0.3);
    }
    .ddk-container .SingleDatePicker_picker__fullScreenPortal {
      background-color: ${props => props.theme.control_background_color};
    }
    .ddk-container .SingleDatePicker_closeButton {
      background: none;
    }
    .ddk-container .SingleDatePicker_closeButton:hover {
      color: ${props => chroma(props.theme.control_background_color).darken().css()};
    }
    .ddk-container .SingleDatePicker_closeButton:focus {
      color: ${props => chroma(props.theme.control_background_color).darken().css()};
    }
    .ddk-container .SingleDatePicker_closeButton_svg {
      background-color: ${props => props.theme.control_background_color};
    }
    .ddk-container .DayPickerKeyboardShortcuts_show__bottomRight::before {
      border-right: 33px solid ${props => props.theme.control_border.color};
    }
    .ddk-container .DayPickerKeyboardShortcuts_show__bottomRight:hover::before {
      border-right: 33px solid ${props => props.theme.control_border.color};
    }
    .ddk-container .DayPickerKeyboardShortcuts_show__topRight::before {
      border-bottom: 26px solid transparent;
      border-right: 33px solid ${props => props.theme.control_border.color};
    }
    .ddk-container .DayPickerKeyboardShortcuts_show__topRight:hover::before {
      border-right: 33px solid ${props => props.theme.control_border.color};
    }
    .ddk-container .DayPickerKeyboardShortcuts_show__topLeft::before {
      border-left: 33px solid ${props => props.theme.control_border.color};
    }
    .ddk-container .DayPickerKeyboardShortcuts_show__topLeft:hover::before {
      border-left: 33px solid ${props => props.theme.control_border.color};
    }
    .ddk-container .DayPickerKeyboardShortcuts_showSpan {
      color: ${props => props.theme.background};
    }
    .ddk-container .DayPickerKeyboardShortcuts_panel {
      background: ${props => props.theme.background};;
      border: 1px solid ${props => props.theme.control_border.color};
    }
    .ddk-container .DayPickerKeyboardShortcuts_closeSvg {
      fill: ${props => props.theme.background};
    }
    .ddk-container .DayPickerKeyboardShortcuts_closeSvg:hover {
      fill: ${props => props.theme.accent}
    }
    .ddk-container .DayPickerKeyboardShortcuts_closeSvg:focus {
      fill: ${props => props.theme.accent}
    }
    .ddk-container .CalendarDay__default {
      border: 1px solid ${props => props.theme.control_border.color};
      color: ${props => props.theme.control_text};
      background: ${props => props.theme.background}
    }
    .ddk-container .CalendarDay__default:hover {
      background: ${props => props.theme.accent}
      border: 1px solid ${props => props.theme.control_border.color};
      color: inherit;
    }
    .ddk-container .CalendarDay__hovered_offset {
      background: ${props => chroma(props.theme.accent).alpha(0.8).css()};
      border: 1px double ${props => props.theme.control_border.color};
      color: inherit;
    }
    .ddk-container .CalendarDay__outside {
      border: 0px;
      background: ${props => props.theme.control_background_color};
      color: ${props => props.theme.control_text}
    }
    .ddk-container .CalendarDay__blocked_minimum_nights {
      background: ${props => props.theme.control_background_color};
      border: 1px solid ${props => props.theme.control_border.color};
      color: ${props => props.theme.control_text}
    }
    .ddk-container .CalendarDay__blocked_minimum_nights:hover {
      background: ${props => props.theme.control_background_color};
      color: ${props => props.theme.control_text};
    }
    .ddk-container .CalendarDay__blocked_minimum_nights:active {
      background: ${props => props.theme.control_background_color};
      color: ${props => props.theme.control_text};
    }
    .ddk-container .CalendarDay__highlighted_calendar {
      background: ${props => chroma(props.theme.accent).alpha(0.8).css()};
      color: ${props => props.theme.control_text}
    }
    .ddk-container .CalendarDay__highlighted_calendar:hover {
      background: ${props => chroma(props.theme.accent).brighten().css()};
      color: ${props => props.theme.control_text};
    }
    .ddk-container .CalendarDay__highlighted_calendar:active {
      background: ${props => chroma(props.theme.accent).brighten().css()};
      color: ${props => props.theme.control_text};
    }
    .ddk-container.ddk-container .CalendarDay:hover {
      background: ${props => props.theme.accent};
    }
    .ddk-container.ddk-container .CalendarDay.CalendarDay__selected_span {
      background: ${props => chroma(props.theme.accent).brighten().css()};
      color: ${props => props.theme.control_text};
      border: 1px double ${props => props.theme.control_border.color};
    }
    .ddk-container.ddk-container .CalendarDay.CalendarDay__selected_span:hover,
    .ddk-container.ddk-container .CalendarDay.CalendarDay__selected_span:active {
      background: ${props => props.theme.accent};
    }
    .ddk-container.ddk-container .CalendarDay.CalendarDay__selected_span:active {
      background: ${props => chroma(props.theme.accent).darken().css()};
      border: 1px double ${props => chroma(props.theme.accent).darken().css()};
      color: ${props => props.theme.control_text};
    }
    .ddk-container.ddk-container .CalendarDay.CalendarDay__selected,
    .ddk-container.ddk-container .CalendarDay.CalendarDay__selected:hover,
    .ddk-container.ddk-container .CalendarDay.CalendarDay__selected:active {
      background: ${props => chroma(props.theme.accent).darken().css()};
      border: 1px double ${props => chroma(props.theme.accent).darken().css()};
      color: ${props => chroma(props.theme.control_text).brighten().css()};
    }
    .ddk-container.ddk-container .CalendarDay.CalendarDay__hovered_span,
    .ddk-container.ddk-container .CalendarDay.CalendarDay__hovered_span:hover {
      background: ${props => chroma(props.theme.accent).brighten().css()};
      border: ${props => chroma(props.theme.accent).brighten().css()};
      color: ${props => chroma(props.theme.accent).darken().css()};
    }
    .ddk-container.ddk-container .CalendarDay.CalendarDay__hovered_span:active {
      background: ${props => chroma(props.theme.accent).brighten().css()};
      border: ${props => chroma(props.theme.accent).brighten().css()};
      color: ${props => chroma(props.theme.accent).darken().css()};
    }
    .ddk-container.ddk-container .CalendarDay.CalendarDay__blocked_calendar {
      background-color: ${props => chroma(props.theme.control_background_color).alpha(0.8).css()}
      border: 1px solid ${props => props.theme.control_border.color};
      color: ${props => props.theme.control_text};
    }
    .ddk-container.ddk-container .CalendarDay.CalendarDay__blocked_calendar:hover,
    .ddk-container.ddk-container .CalendarDay.CalendarDay__blocked_calendar:active,
    .ddk-container.ddk-container .CalendarDay.CalendarDay__blocked_out_of_range,
    .ddk-container.ddk-container .CalendarDay.CalendarDay__blocked_out_of_range:hover,
    .ddk-container.ddk-container .CalendarDay.CalendarDay__blocked_out_of_range:active,
    .ddk-container.ddk-container .CalendarDay.CalendarDay__hovered_start_first_possible_end,
    .ddk-container.ddk-container .CalendarDay.CalendarDay__hovered_start_blocked_min_nights {
      background-color: ${props => chroma(props.theme.control_background_color).alpha(0.8).css()}
      border: 1px solid ${props => props.theme.control_border.color};
      color: ${props => props.theme.control_text};
    }
    .ddk-container .CalendarMonth {
      background: ${props => props.theme.background};
    }
    .ddk-container .CalendarMonth_caption {
      color: ${props => props.theme.control_text};
    }
    .ddk-container .CalendarMonthGrid {
      background: ${props => props.theme.control_background_color};
    }
    .ddk-container .DayPickerNavigation_button__default {
      border: 1px solid ${props => props.theme.control_border.color};
      background-color: ${props => props.theme.background}
      color: ${props => props.theme.control_text}
    }
    .ddk-container .DayPickerNavigation_button__default:focus {
      border: 1px solid ${props => props.theme.control_border.color};
    }
    .ddk-container .DayPickerNavigation_button__default:hover {
      border: 1px solid ${props => props.theme.control_border.color};
    }
    .ddk-container .DayPickerNavigation_button__default:active {
      background: ${props => props.theme.control_background_color}
    }
    .ddk-container .DayPickerNavigation_button__disabled {
      cursor: default;
      border: 1px solid ${props => props.theme.control_border.color}
    }
    .ddk-container .DayPickerNavigation_button__disabled:focus {
      border: 1px solid ${props => props.theme.control_border.color}
    }
    .ddk-container .DayPickerNavigation_button__disabled:hover {
      border: 1px solid ${props => props.theme.control_border.color}
    }
    .ddk-container .DayPickerNavigation_button__disabled:active {
      background: none
    }
    .ddk-container .DayPickerNavigation_button__verticalDefault {
      background: ${props => props.theme.control_background_color};
      box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
    }
    .ddk-container .DayPickerNavigation_svg__horizontal {
      fill: ${props => chroma(props.theme.control_text).alpha(0.8).css()};
    }
    .ddk-container .DayPickerNavigation_svg__vertical {
      fill: ${props => chroma(props.theme.control_text).alpha(0.8).css()};
    }
    .ddk-container .DayPickerNavigation_svg__disabled {
      background-color: ${props => chroma(props.theme.control_background_color).alpha(0.8).css()};
    }
    .ddk-container .DayPicker {
      background-color: ${props => chroma(props.theme.control_background_color).alpha(0.8).css()};
    }
    .ddk-container .DayPicker__horizontal {
      background: ${props => props.theme.control_background_color};
    }
    .ddk-container .DayPicker__withBorder {
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05),0 0 0 1px rgba(0, 0, 0, 0.07);
    }
    .ddk-container .DayPicker_weekHeader {
      color: ${props => props.theme.control_text};
    }
    .ddk-container .DateInput {
      background: ${props => props.theme.control_background_color};
    }
    .ddk-container .DateInput__disabled {
      color: ${props => chroma(props.theme.control_text).alpha(0.8).css()};
      background: none;
    }
    .ddk-container .DateInput_input {
      color: ${props => props.theme.control_text};
      background-color: ${props => props.theme.control_background_color};
    }
    .ddk-container .DateInput_input__focused {
      background: ${props => props.theme.control_background_color};
    }
    .ddk-container .DateInput_input__disabled {
      background: ${props => props.theme.control_background_color};
    }
    .ddk-container .DateInput_fangShape {
      fill: ${props => props.theme.control_background_color};
    }
    .ddk-container .DateInput_fangStroke {
      stroke: ${props => props.theme.control_background_color};
      fill: transparent;
    }
    .ddk-container .DateRangePickerInput {
      background-color: ${props => props.theme.control_background_color};
    }
    .ddk-container .DateRangePickerInput__disabled {
      background: ${props => chroma(props.theme.control_background_color).alpha(0.8).css()};
    }
    .ddk-container .DateRangePickerInput__withBorder {
      border: none;
      border-color: ${props => props.theme.control_border.color};
    }
    .ddk-container .DateRangePickerInput_arrow {
      color: ${props => props.theme.control_text};
    }
    .ddk-container .DateRangePickerInput_arrow_svg {
      fill: ${props => chroma(props.theme.control_border.color).darken().css()};
    }
    .ddk-container .DateRangePickerInput_clearDates_default:focus {
      background: ${props => props.theme.control_background_color};
    }
    .ddk-container .DateRangePickerInput_clearDates_default:hover {
      background: ${props => props.theme.control_background_color};
    }
    .ddk-container .DateRangePickerInput_clearDates_svg {
      fill: ${props => chroma(props.theme.control_border.color).darken().css()};
    }
    .ddk-container .DateRangePickerInput_calendarIcon_svg {
      fill: ${props => chroma(props.theme.control_border.color).darken().css()};
    }
    .ddk-container .DateRangePicker_picker {
      background-color: ${props => props.theme.control_background_color};
    }
    .ddk-container .DateRangePicker_picker__portal {
      background-color: rgba(0, 0, 0, 0.3);
    }
    .ddk-container .DateRangePicker_picker__fullScreenPortal {
      background-color: ${props => props.theme.control_background_color};
    }
    .ddk-container .DateRangePicker_closeButton:hover {
      color: ${props => chroma(props.theme.control_text).darken().css()};
    }
    .ddk-container .DateRangePicker_closeButton:focus {
      color: ${props => chroma(props.theme.control_text).darken().css()};
    }
    .ddk-container .DateRangePicker_closeButton_svg {
      fill: ${props => props.theme.control_background_color};
    }
`
export default themedStyles;
